import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="w-full max-w-[95%] lg:max-w-[85%] mx-auto border-x border-b border-gridline scroll-mt-24 mb-10 md:mb-20" data-id="element-15">
      <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="relative aspect-[4/3] lg:aspect-auto lg:min-h-[60vh] overflow-hidden border-b lg:border-b-0 lg:border-r border-gridline" data-id="element-17">
          <img src="https://images.unsplash.com/photo-1470337458703-46ad1756a187?auto=format&fit=crop&w=1600&q=80" alt="Elegantly styled cocktails and small plates on a dark bar surface" className="absolute inset-0 h-full w-full object-cover" data-id="element-18" />
          <div className="absolute inset-0 bg-black/40" aria-hidden="true" data-id="element-19" />
        </motion.div>

        <div className="flex flex-col justify-center px-8 py-20 md:px-16 md:py-32" data-id="element-20">
          <span className="text-accent font-bold uppercase tracking-[0.35em] text-xs" data-id="element-21">
            About Us
          </span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.6
        }} className="mt-6 text-white font-black uppercase leading-none tracking-tight text-4xl md:text-6xl" data-id="element-22">
            Crafted to
            <br data-id="element-23" />
            Perfection
          </motion.h2>
          <div className="mt-6 h-px w-16 bg-accent" aria-hidden="true" data-id="element-24" />
          <p className="mt-8 max-w-md text-white/60 text-sm md:text-base leading-relaxed" data-id="element-25">
            Sips &amp; Nibbles is a premium hospitality experience built around
            artful mixology and gourmet small chops. We bring sophistication to
            every occasion — pairing meticulously crafted cocktails and
            mocktails with bold, tactile bites.
          </p>
          <p className="mt-5 max-w-md text-white/60 text-sm md:text-base leading-relaxed" data-id="element-26">
            From intimate gatherings to large-scale activations, every detail is
            designed, produced, and served with intention. Sip. Savour.
            Celebrate.
          </p>
        </div>
      </div>
    </section>;
}